import { render, staticRenderFns } from "./iconTrabajo-white.vue?vue&type=template&id=58fa6284&scoped=true&"
import script from "./iconTrabajo-white.vue?vue&type=script&lang=js&"
export * from "./iconTrabajo-white.vue?vue&type=script&lang=js&"
import style0 from "./iconTrabajo-white.vue?vue&type=style&index=0&id=58fa6284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa6284",
  null
  
)

export default component.exports